module.exports = __webpack_public_path__ + "img/风压雪压气温表@3x.png";